// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"391":"be2318c98b532674","437":"0b4a79e3157e7e64","501":"c8857375d4f0aa03","735":"7325ee05f63dd7ba","881":"2a41eca8271d82a3"}[chunkId] + ".js";
};